// Report catalog: categories and report IDs used by backend /reports/:reportType
export const REPORT_CATEGORIES = [
  {
    id: "inventory",
    title: "Inventory Reports",
    icon: "Inventory2",
    reports: [
      { id: "stock-summary", label: "Stock Summary Report" },
      { id: "stock-detailed", label: "Stock Detailed Report" },
      { id: "stock-movement", label: "Stock Movement Report" },
      { id: "product-item-report", label: "Product Item Activity Report" },
      { id: "batch-wise-stock", label: "Batch-wise Stock Report" },
      { id: "expiry-report", label: "Expiry Report" },
      { id: "low-stock", label: "Low Stock Report" },
      { id: "out-of-stock", label: "Out of Stock Report" },
      { id: "item-wise-profit", label: "Item-wise Profit Report" },
      { id: "warehouse-wise-stock", label: "Warehouse-wise Stock Report" },
      { id: "category-wise-stock", label: "Category-wise Stock Report" },
      { id: "stock-valuation", label: "Stock Valuation Report" },
      { id: "damage-stock-report", label: "Damage Stock Report" },
      { id: "negative-stock", label: "Negative Stock Report" },
      { id: "slow-fast-moving", label: "Slow Moving / Fast Moving Report" },
      { id: "stock-audit-report", label: "Stock Audit Discrepancy Report" },
      { id: "stock-ledger-summary", label: "Stock Ledger Summary (Opening-In-Out-Closing)" },
      { id: "stock-item-list", label: "Stock Item List (All Products)" },
    ],
  },
  {
    id: "purchase",
    title: "Purchase Reports",
    icon: "ShoppingCart",
    reports: [
      { id: "purchase-summary", label: "Purchase Summary" },
      { id: "purchase-detailed", label: "Purchase Detailed" },
      { id: "supplier-wise-purchase", label: "Supplier-wise Purchase" },
      { id: "purchase-return", label: "Purchase Return Report" },
      { id: "grn-report", label: "GRN Report" },
      { id: "pending-purchase-orders", label: "Pending Purchase Orders" },
      { id: "supplier-ledger", label: "Supplier Ledger (Statement of Account)" },
      { id: "input-vat", label: "Input VAT Report (UAE 5%)" },
      { id: "purchase-comparison", label: "Purchase Comparison Report" },
    ],
  },
  {
    id: "sales",
    title: "Sales Reports",
    icon: "PointOfSale",
    reports: [
      { id: "sales-summary", label: "Sales Summary" },
      { id: "sales-detailed", label: "Sales Detailed" },
      { id: "customer-wise-sales", label: "Customer-wise Sales" },
      { id: "customer-ledger", label: "Customer Ledger (Statement of Account)" },
      { id: "sales-return", label: "Sales Return Report" },
      { id: "daily-sales", label: "Daily Sales Report (POS)" },
      { id: "item-wise-sales", label: "Item-wise Sales Report" },
      { id: "product-sales-report", label: "Product Sales Report" },
      { id: "service-sales-report", label: "Service Sales Report" },
      { id: "profit-report", label: "Profit Report" },
      { id: "bill-wise-profit", label: "Bill Wise Profit Report" },
      { id: "sales-by-salesperson", label: "Sales by Salesperson" },
      { id: "credit-sales", label: "Credit Sales Report" },
      { id: "output-vat", label: "Output VAT Report" },
      { id: "payment-collection", label: "Payment Collection Report" },
      { id: "discount-report", label: "Discount Report" },
      { id: "missing-invoice-report", label: "Missing Invoice Report" },
      { id: "single-day-activity", label: "Single Day Activity Report" },
    ],
  },
  {
    id: "financial",
    title: "Financial Reports",
    icon: "AccountBalance",
    reports: [
      { id: "day-book", label: "Day Book (Opening & Closing)" },
      { id: "monthly-financial-summary", label: "Monthly Financial Summary (Paid)" },
      { id: "profit-loss", label: "Profit & Loss Statement" },
      { id: "balance-sheet", label: "Balance Sheet" },
      { id: "trial-balance", label: "Trial Balance" },
      { id: "cash-flow", label: "Cash Flow Statement" },
      { id: "account-statement", label: "Account Statement (Ledger)" },
      { id: "customer-ledger", label: "Customer Ledger Statement" },
      { id: "supplier-ledger", label: "Supplier Ledger Statement" },
      { id: "accounts-receivable", label: "Accounts Receivable" },
      { id: "accounts-payable", label: "Accounts Payable" },
      { id: "tax-summary", label: "Tax Summary Report" },
      { id: "vat-return", label: "VAT Return Report (UAE FTA format)" },
      { id: "expense-report", label: "Expense Report" },
      { id: "income-report", label: "Income Report" },
    ],
  },
  {
    id: "management",
    title: "Management / Dashboard Reports",
    icon: "Dashboard",
    reports: [
      { id: "business-overview", label: "Business Overview Dashboard" },
      { id: "top-selling-products", label: "Top Selling Products" },
      { id: "top-customers", label: "Top Customers" },
      { id: "top-suppliers", label: "Top Suppliers" },
      { id: "monthly-comparison", label: "Monthly Comparison Report" },
      { id: "yearly-growth", label: "Yearly Growth Report" },
    ],
  },
  {
    id: "compliance",
    title: "Important Reports (Mandatory for Compliance)",
    icon: "Gavel",
    reports: [
      { id: "input-vat-report", label: "Input VAT Report" },
      { id: "output-vat-report", label: "Output VAT Report" },
      { id: "vat-return-summary", label: "VAT Return Summary" },
      { id: "trn-invoice-report", label: "TRN-based Invoice Report" },
      { id: "tax-invoice-print", label: "Tax Invoice Print Format" },
    ],
  },
  {
    id: "van-sales",
    title: "Van Sales Reports",
    icon: "DirectionsCar",
    reports: [
      { id: "van-sales-summary", label: "Van Sales Summary" },
      {
        id: "van-trip-reconciliation",
        label: "Van Trip Reconciliation Report",
      },
      { id: "van-stock-report", label: "Van Stock Report" },
    ],
  },

];

export const getReportById = (id) => {
  for (const cat of REPORT_CATEGORIES) {
    const r = cat.reports.find((x) => x.id === id);
    if (r) return { ...r, categoryId: cat.id, categoryTitle: cat.title };
  }
  return null;
};

export const getCategoryById = (id) =>
  REPORT_CATEGORIES.find((c) => c.id === id) || null;
